import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { VideoService } from '@core/services/video.service';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { KwoConnectTagComponent } from '../kwo-connect-tag/kwo-connect-tag.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
	selector: 'kwo-video-item',
	templateUrl: './video-item.component.html',
	styleUrls: ['./video-item.component.scss'],
	standalone: true,
	imports: [CommonModule, SafeHtmlPipe, KwoConnectTagComponent, FaIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoItemComponent implements OnInit {

	@Input() video: any;
	@Input() mode: string = '';
	@Input() useTransition: boolean = false;
	@Input() showEpisodes: boolean = false;

	private router = inject(Router);
	private videoService = inject(VideoService);

	mouseDownTimestamp: number = 0;
	watchedList = this.videoService.watchedList;

	ngOnInit(): void {

		this.video.watched = this.watchedList().includes(this.video.video);
	}

	goToVideo(slug: string) {

		if (Date.now() - this.mouseDownTimestamp < 200) {

			this.router.navigate(['/video/', slug]);
		}
	}

	dragStart() {

		this.mouseDownTimestamp = Date.now();
	}
}